import { StoreExt } from '@utils/reactExt'
import { action, observable, runInAction } from 'mobx'

class AddressStoreG extends StoreExt {

    @observable isCheckout: boolean = false
    @observable payScriptUrl: string = ''
    @observable orderStatus: any = ''
    @action
    getCheckout(val) {
        this.isCheckout = val
    }
    @action
    getCheckOutId(val, orderId) {
        sessionStorage.setItem('CHECKOUTID', val)
        sessionStorage.setItem('ORDERID', orderId)
    }

    @action
    initOrderStatus = () => {
        this.orderStatus = ''
    }

    @action
    getPayScript = async () => {
        try {
            const res = await this.api.queryConfigValue({group: 'aci', name: 'url'});
            runInAction(() => {
                this.payScriptUrl = res
            })
        } catch (error) {}
    }

    // 支付结果查询
    @action
    getResult = async () => {
        try {
            let res
            if (!sessionStorage.getItem('paymentId')) {
                res = await this.api.getPaymentStatus({ checkoutId: sessionStorage.getItem('CHECKOUTID'), orderId: sessionStorage.getItem('ORDERID') });
                sessionStorage.setItem('paymentId', res.paymentId)
            } else {
                res = await this.api.getPaymentReport({ paymentId: sessionStorage.getItem('paymentId')});
            }
            runInAction(() => {
                this.orderStatus = res.success
            })
        } catch (error) {
            runInAction(() => {
                this.orderStatus = false
            })
        }
    }
}

const addressStoreG = new AddressStoreG()
export { addressStoreG, AddressStoreG }
